// https://www.w3.org/TR/2019/NOTE-wai-aria-practices-1.1-20190207/examples/menu-button/js/PopupMenuLinks.js
export default function A11yPopup(node, controller) {
  this.KEYCODE_TAB = 9

  this.node = node
  if (this.node.dataset.inert) {
    this.node.inert = true
  }

  this.controller = controller
  this.parentMenu = this.node.parentNode.closest('ul')
  this.onKeydown = this.handleTab.bind(this)
  this.focusable = this.node.querySelectorAll(
    'a[href], button, textarea, input[type="text"], input[type="radio"], input[type="checkbox"], input[type="search"], select',
  )
  this.events = {
    open: new CustomEvent('A11yPopupOpen', {
      detail: {
        A11yPopup: this,
      },
    }),
    close: new CustomEvent('A11yPopupClose', {
      detail: {
        A11yPopup: this,
      },
    }),
  }
}

A11yPopup.prototype.open = function () {
  this.node.dataset.classname
    ? this.node.classList.add(`${this.node.dataset.classname}--expanded`)
    : this.node.classList.add('expanded')

  window.dispatchEvent(this.events.open)
  this.node.dispatchEvent(this.events.open)

  if (this.node.dataset.inert) {
    this.node.inert = false
  }

  if (this.node.dataset.autofocus) {
    this.focusable[0].focus()
  }

  this.node.addEventListener('keydown', this.onKeydown)
}

A11yPopup.prototype.close = function (focus) {
  this.node.querySelectorAll('[aria-expanded]').forEach((element) => {
    element.setAttribute('aria-expanded', false)
  })

  this.node.querySelectorAll('.expanded').forEach((element) => {
    element.classList.remove('expanded')
  })

  this.node.dataset.classname
    ? this.node.classList.remove(`${this.node.dataset.classname}--expanded`)
    : this.node.classList.remove('expanded')

  window.dispatchEvent(this.events.close)

  this.node.dispatchEvent(this.events.close)
  this.node.removeEventListener('keydown', this.onKeydown)

  if (this.node.dataset.inert) {
    this.node.inert = true
  }

  if (focus) this.controller.node.focus()
}

A11yPopup.prototype.handleTab = function (e) {
  const visibleFocusable = [...this.focusable].filter(
    (element) => element.offsetHeight > 0,
  )
  const firstFocusableElement = visibleFocusable[0]
  const lastFocusableElement = visibleFocusable[visibleFocusable.length - 1]
  const isTabPressed = e.key === 'Tab' || e.keyCode === this.KEYCODE_TAB

  if (!isTabPressed) {
    return
  }

  if (!e.shiftKey) {
    if (document.activeElement === lastFocusableElement) {
      this.controller.togglePopup()
      e.preventDefault()
    }
  }

  if (e.shiftKey) {
    if (document.activeElement === firstFocusableElement) {
      this.controller.togglePopup()
      e.preventDefault()
    }
  }
}
